import { formatCompactAmount } from "@components/SubscribeToPayRangeDialog/subscribeToPayRangeUtils";

export const READINESS_LADDER_TONES = {
  0: "neutral",
  50: "danger",
  100: "success",
  150: "info",
};

export function formatMoneyAbbreviated(amount, currency = "USD") {
  if (amount == null || amount === "") return "—";
  const symbol = currency === "USD" ? "$" : `${currency} `;
  return `${symbol}${formatCompactAmount(amount)}`;
}

export function formatFullMoney(amount, currency = "USD") {
  if (amount == null || amount === "") return "";
  const n = Number(amount);
  if (!Number.isFinite(n)) return String(amount);
  const symbol = currency === "USD" ? "$" : `${currency} `;
  return `${symbol}${Math.abs(n).toLocaleString("en-US", { maximumFractionDigits: 0 })}`;
}

export function buildDeltaBannerText(baseSalary, fairPayToday, fairPayDelta, readinessPct) {
  const readinessLabel = `${Math.round(Number(readinessPct) || 0)}%`;

  if (Number(baseSalary) === Number(fairPayToday)) {
    return `at Fair Pay with equivalent readiness of ${readinessLabel}`;
  }

  if (!fairPayDelta) return "";

  const { amount, pct, direction, withinTolerance } = fairPayDelta;
  const amountStr = formatFullMoney(amount);
  const pctValue = Number(pct);
  const signedPct =
    pctValue > 0 ? `+${pctValue}%` : pctValue < 0 ? `${pctValue}%` : "0%";
  const directionWord =
    direction === "below" ? "below" : direction === "above" ? "above" : "at";
  const toleranceWord = withinTolerance ? "inside" : "outside";

  return `${amountStr} ${directionWord} Fair Pay (${signedPct} ${toleranceWord} tolerance) with equivalent readiness of ${readinessLabel}`;
}

export function getDeltaBannerVariant(baseSalary, fairPayToday, fairPayDelta) {
  if (Number(baseSalary) === Number(fairPayToday)) {
    return "inside";
  }
  if (!fairPayDelta?.withinTolerance) {
    return "outside";
  }
  return "inside";
}

export function resolveFlagSrc(countryCode) {
  if (!countryCode) return "";
  if (/^https?:\/\//i.test(countryCode) || countryCode.includes("/")) {
    return countryCode;
  }
  return `https://flagcdn.com/${countryCode.toLowerCase()}.svg`;
}

export function formatReadinessLadderValue(value) {
  if (value == null || value === "") return "—";
  return formatCompactAmount(value);
}
